import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { MultiSelect, MultiSelectProps } from './MultiSelect'

export type MultiSelectFieldProps<Item> = Omit<MultiSelectProps<Item>, 'value' | 'onChange'> & {
  name: string
  validate?: FieldValidator<Item[]>
}

export function MultiSelectField<Item extends { id: string }>({
  name,
  validate,
  ...props
}: MultiSelectFieldProps<Item>) {
  const form = useForm()
  const { input, meta } = useField<Item[]>(name, { validate })

  const errorMessage = meta.error || meta.submitError || props.error

  return (
    <MultiSelect<Item>
      {...input}
      value={input.value ?? []}
      onChange={(value) => form.change(name, value)}
      {...props}
      error={Boolean(meta.touched && errorMessage)}
      formHelperText={(meta.touched && errorMessage) || undefined}
    />
  )
}
